import { Reason, Category } from "src/common/types/visit";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { toast } from "react-toastify";
import { sortVisitOptions } from "../../common/utilities/visitOptionUtils";

export default function internalReasonsReducer(state: Category[] = [], action: AnyAction): Category[] {
  switch (action.type) {
    case internalActionKeys.PATCH_REASON_SUCCESS:
      return updateReasons(state, action.updatedReason);
    case internalActionKeys.PATCH_REASON_FAILURE:
      return state;
    default:
      return state;
  }
}

const updateReasons = (categories: Category[], updatedReason: Reason): Category[] => {
  const categoriesCopy = [
    ...categories.map(c => ({
      ...c,
      reasons: [...c.reasons.map(r => ({ ...r }))]
    }))
  ];
  const category = categoriesCopy.find(c => c.id === updatedReason.categoryId);
  if (category) {
    const reasonIndex = category.reasons.findIndex(r => r.id === updatedReason.id);
    if (reasonIndex > -1) {
      category.reasons[reasonIndex] = updatedReason;
      return sortVisitOptions(categoriesCopy) as Category[];
    } else {
      toast.error("An error occurred when trying to update reasons");
      return categories;
    }
  } else {
    toast.error("An error occurred when trying to update reasons");
    return categories;
  }
};
